import React from "react";
import "./CSS/Crafted.css";

import img1 from "./IMAGES/craft.jpeg";
import img2 from "./IMAGES/fresh.jpeg";
import img3 from "./IMAGES/handcraft.jpeg";

const data = [
  {
    image: img1,
    title: "Crafted by Hands, Designed for Grace",
    desc: "Our artisans pour passion and precision into every saree, creating pieces that celebrate heritage and beauty.",
  },
  {
    image: img2,
    title: "Fresh styles curated for the modern woman who loves tradition.",
    desc: "Each saree, kurti set, dress, blouse, top, lehenga, and kids outfit reflects our promise of premium fabrics and trusted artistry.",
  },
  {
    image: img3,
    title: "Handcrafted Sarees, Woven With Love",
    desc: "Intricate hand embroidery crafted stitch by stitch by skilled artisans.",
  },
];

const HeroSection = () => {
  return (
    <div className="hero-main">
      {data.map((item, index) => (
        <div className="hero-wrappers" key={index}>
          <div className="hero-borders">
            <div
              className="hero-containers"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="hero-overlays"></div>

              <div className="hero-contents">
                <h1>{item.title}</h1>
                <p>{item.desc}</p>
                 {index === 1 && (
                  <button className="btn primary">
                    View All New Arrival
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HeroSection;